// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const NonVisualFieldLegend = ({ isLiveUpdate = false }) => {
  const { t } = useTranslation();

  // Smaller text on narrow screens in the live update view, matching
  // VisualAcuityHeader/VisualAcuityScale/VisualAcuityIndex.
  const fontSize = isLiveUpdate ? { xs: "12px", sm: "14px" } : "14px";

  return (
    <Grid item display="flex" columnGap="16px" alignItems="center">
      <Typography fontSize={fontSize}>{t("Legend")}:</Typography>

      {isLiveUpdate && (
        <Typography fontSize={fontSize} color="#E2772E">
          {t("Current")}
        </Typography>
      )}

      <Typography fontSize={fontSize} color="#13A321">
        {t("Seen")}
      </Typography>

      <Typography fontSize={fontSize} color="#B21515">
        {t("Not Seen")}
      </Typography>

      <Typography
        fontSize={fontSize}
        sx={{
          padding: "4px 8px",
          color: "#202338",
          backgroundImage:
            "linear-gradient(0deg, #E7C43C60 25%, #FFF 25%, #FFF 50%, #E7C43C60 50%, #E7C43C60 75%, #FFF 75%, #FFF 100%)",
          backgroundSize: "8px 8px",
        }}
      >
        {t("Skipped")}
      </Typography>
    </Grid>
  );
};

export default NonVisualFieldLegend;
